import { Store } from "redux";
import { SDK } from "@sdk";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { SupplierPaymentMethodsSlice } from "./supplier-payment-methods.slice";
import { iSupplierPaymentMethod } from "@sdk/supplier-payment-methods/supplier-payment-method-model";
import { supplierPaymentMethodsDefaultQueryConfig } from "./supplier-payment-methods-default-query";
import { QueryConfig } from "@/store/utils/query-config";

export const {
  loadEntityQueries: loadSupplierPaymentMethodsQuery,
  loadEntityById: loadSupplierPaymentMethodById,
  loadMoreEntityQueries: loadMoreSupplierPaymentMethodsQueries,
} = CreateHelpersForEntity<iStore, iSupplierPaymentMethod>({
  sliceName: "supplierPaymentMethods",
  slice: SupplierPaymentMethodsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 25,
  loadEntityQueryProvider: (query) => SDK.supplierPaymentMethods.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.supplierPaymentMethods.getById(entityId),
});

export const LoadAllSupplierPaymentMethods = (
  store: Store<iStore>,
  forceReload?: boolean
) =>
  loadSupplierPaymentMethodsQuery(
    supplierPaymentMethodsDefaultQueryConfig,
    "all"
  )(store, forceReload);

export const LoadSupplierPaymentMethodsByBrand = (
  brandId: string,
  store: Store<iStore>,
  forceReload?: boolean
) => {
  const queryConfig: QueryConfig = {
    query: { brandId },
    options: { sortBy: ["createdAt"] },
  };
  return loadSupplierPaymentMethodsQuery(
    queryConfig,
    `byBrand:${brandId}`
  )(store, forceReload);
};
